export default __webpack_public_path__ + "static/media/sortIcon.3bc1fb1f.svg";